function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'RolesTree',
  props: {
    treeData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    defaultCheckedKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rolesList: {
      type: [Array, Object],
      default: function _default() {
        return [];
      }
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    defaultCheckedKeys: {
      handler: function handler(nVal, oVal) {
        if (this.isAdmin) {
          this.$refs.tree.setCheckedKeys(nVal);
        }
      },
      deep: true
    }
  },
  data: function data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label',
        activeId: 0,
        disabled: function disabled(data, node) {
          return data.disabled;
        }
      },
      checkList: [],
      checkValue: [],
      listOne: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    if (this.rolesList.length > 0) {
      this.rolesList.map(function (item) {
        _this.checkValue.push(Number(item));
        _this.listOne.push(Number(item));
      });
    }
  },
  methods: {
    handelCheck: function handelCheck(checkedNode, checkedKeys) {
      if (checkedKeys.checkedKeys.indexOf(checkedNode.value) != -1) {
        // 节点选中
        this.checkedNodeFn(checkedNode, 2);
        this.listOne = this.checkValue;
      } else {
        // 节点未选中
        this.checkedNodeFn(checkedNode, 1);
        this.listOne = this.checkValue;
      }
    },
    // tree节点点击
    handelClick: function handelClick(data, node, element) {
      var _this2 = this;
      var that = this;
      if (data.apis) {
        this.checkList = data.apis.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            is_default: _this2.listOne.some(function (id) {
              return id === item.value;
            })
          });
        });
      } else {
        that.checkList = [];
      }
      setTimeout(function () {
        that.checkValue = that.listOne;
      }, 300);
    },
    checkedNodeFn: function checkedNodeFn(data, val) {
      var _this3 = this;
      if (data.apis) {
        var len = data.apis.length;
        if (len > 0) {
          var _loop = function _loop(i) {
            if (val !== 1) {
              _this3.$nextTick(function () {
                data.apis[i].is_default = true;
                _this3.checkValue.push(data.apis[i].value);
              });
            } else {
              data.apis[i].is_default = false;
              var filteredArray = _this3.checkValue.filter(function (value) {
                return value !== data.apis[i].value;
              });
              _this3.checkValue = filteredArray;
            }
          };
          for (var i = 0; i < len; i++) {
            _loop(i);
          }
        }
      }
      if (data.children) {
        data.children.forEach(function (item) {
          _this3.checkedNodeFn(item, val);
        });
      }
    },
    handelCheckChange: function handelCheckChange(val, item) {
      var _this4 = this;
      if (val) {
        this.checkValue.push(item.value);
      } else {
        this.checkValue = this.checkValue.filter(function (val) {
          return val != item.value;
        });
      }
      this.listOne = [];
      if (this.checkValue.length) {
        this.checkValue.map(function (item) {
          _this4.listOne.push(item);
        });
      }
    },
    getNodeValue: function getNodeValue() {
      var _this5 = this;
      return new Promise(function (resolve, reject) {
        var obj = {};
        obj.rules = _this5.$refs.tree.getCheckedKeys(true);
        obj.apis = _this5.listOne;
        resolve(obj);
      });
    }
  }
};